<template>
  <b-modal v-model="modalAberto" size="xl" @hidden="fecharModal" button-size="md" hide-footer :title="prefix + title">
    <b-form-row>
      <b-col lg="2" sm="12" class="text-left">
        <lg-form-date invalidFeedback="A data limite deve ser informada!" description="" v-model="form.dataDe"
          label="Criação:" />
      </b-col>

      <b-col lg="2" sm="12" class="text-left">
        <lg-form-date invalidFeedback="A data limite deve ser informada!" description="" v-model="form.dataAte"
          label="Até:" />
      </b-col>
      <b-button class=" mb-2 mt-2" size="sm" pill variant="primary" @click="load" title="Buscar">
        <div>
          <b-icon icon="search" />
        </div>
      </b-button>
    </b-form-row>

    <b-card bg-variant="light">
      <b-table responsive class="mt-4" small :busy="busy" :items="safeRecords" :fields="tableFields" hover show-empty>
        <template #table-busy>
          <div class="text-center text-primary my-2">
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </template>

        <template #empty>
          <p>Nenhum registro encontrado</p>
        </template>
      </b-table>
      <b-row class="mt-3" v-if="hasRecords">
        <b-col cols="6" class="d-flex align-items-center" style="font-size: 12px">
          Página {{ page }} de {{ totalPage }} - {{ total }} registros
          <b-form-select size="sm" v-model="perPage" @change="load" :options="perPageOptions" class="ml-2" />
        </b-col>
        <b-col cols="6" class="d-flex justify-content-end">
          <b-pagination v-model="page" :per-page="perPage" :total-rows="total" class="my-2" />
        </b-col>
      </b-row>
    </b-card>
  </b-modal>
</template>
<script>
import LgFormDate from "@/core/components/Form/LgFormDate.vue"
import ResourceService from "@/core/api/ResourceService"
import { ListResourceMixin } from "@/core/mixins/resource"
import moment from "moment"

export default {
  name: "ModalHistoricoSenado",
  components: { LgFormDate },
  props: {
    almoxarifadoProdutoId: Number,
    prefix: {
      type: String,
      default: "Pedidos > Cadastro",
    },
    title: {
      type: String,
      default: " > Histórico de Pedidos",
    },
  },

  mixins: [ListResourceMixin],

  beforeMount() {
    this.$service = new ResourceService(
      `/api/pedidos-itens/historico/${this.almoxarifadoProdutoId}`
    )
  },

  mounted() {
    this.load()
  },

  watch: {
    page() {
      this.load()
    },
  },

  data() {
    return {
      perPage: 10,
      perPageOptions: [10, 25, 50, 100],
      total: 0,
      totalPage: 1,
      records: [],
      modalAberto: true,
      busy: false,
      form: {
        dataDe: moment().subtract(1, "months").format("YYYY-MM-DD"),
        dataAte: moment().format("YYYY-MM-DD"),
        numeroPedido: null,
        justificativa: "",
        quantidade: 0,
      },
    }
  },

  computed: {
    tableFields() {
      return [
        { key: "dhCriacao", label: "Data", formatter: this.formatDate },
        { key: "pedidoId", label: "N Pedido" },
        { key: "justificativa", label: "Justificativa" },
        { key: "qtdRetirada", label: "Quant." },
      ]
    },
    selectedDataDe() {
      if (!this.form.dataDe) return null
      return moment(this.form.dataDe, "YYYY-MM-DD").format("DD/MM/YYYY")
    },

    selectedDataAte() {
      if (!this.form.dataAte) return null
      return moment(this.form.dataAte, "YYYY-MM-DD").format("DD/MM/YYYY")
    },

    safeRecords() {
      return this.records || []
    },

    hasRecords() {
      return Array.isArray(this.records) && this.records.length > 0
    },
  },

  methods: {
    fecharModal() {
      this.modalAberto = false
      this.$emit("close")
    },

    async load() {
      this.busy = true
      let filtro = {}
      if (this.form.dataDe != null && this.form.dataDe != "") {
        const dateDe = moment(this.form.dataDe, "YYYY-MM-DD").format(
          "MM/DD/YYYY"
        )
        filtro.dataDe = dateDe
      }

      if (this.form.dataAte != null && this.form.dataAte != "") {
        const dateAte = moment(this.form.dataAte, "YYYY-MM-DD").format(
          "MM/DD/YYYY"
        )
        filtro.dataAte = dateAte
      }
      await this.$loadResource({
        limit: this.perPage,
        page: this.page,
        params: filtro,
      })
        .then(response => {
          if (response.content) {
            this.records = response.content
            this.total = response.totalElements
            this.totalPage = response.totalPages
          } else {
            this.records = []
          }
        })
        .finally(() => {
          this.busy = false
        })
    },
    formatDate(value) {
      return moment(value).format("DD/MM/yyyy")
    },
  },
}
</script>

<style>
.images-container {
  display: flex;
  margin-left: 47%;
}
</style>
